import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { OAuthModule, OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment.development';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { authInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes),
    OAuthService,
  importProvidersFrom(
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['amrize.org', 'amrize-email-sign-dev.uc.r.appspot.com'],
        sendAccessToken: false,
        customUrlValidation(url) {
          try {
            const parsedUrl = new URL(url);
            const hostname = parsedUrl.hostname;

            return ['amrize.org', 'amrize-email-sign-dev.uc.r.appspot.com'].some(allowed => hostname.endsWith(allowed));
          } catch (e) {
            return false; // Invalid URL
          }
        },

      }
    })
  ),
  provideHttpClient(withInterceptors([authInterceptor])),
  provideAnimations(),
  provideClientHydration(),
  provideOAuthClient(),


    // {
    //   provide: OAuthService,
    //   useFactory: () => {
    //     const oauthService = new OAuthService();
    //     oauthService.configure(environment);
    //     oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
    //       if (!oauthService.hasValidAccessToken()) {
    //         oauthService.initCodeFlow();
    //       }
    //     });
    //     return oauthService;
    //   },
    // },
  ]
};
